import { render, staticRenderFns } from "./IncomePage.vue?vue&type=template&id=4d4cbbb8"
import script from "./IncomePage.vue?vue&type=script&lang=js"
export * from "./IncomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports